<template>
  <div class="Kanit mx-auto bg-home" style="max-width: 500px; height:100%;  position: relative;">
    <template v-if="!loading">
      <!-- Header -->
      <div>
        <Header></Header>
      </div>

      <div style="position: absolute; bottom: 24px; width: 100%; left: 0;">
        <v-row
          class="px-4"
        >
          <v-col>
            <v-card
              class="pa-2 home-btn"
              outlined
              @click="changePage('about')"
            >
              <div class="text-center mt-2">
                <img src="@/assets/images/home-icon-1.png" height="48px">
              </div>
              <div>LAMY CLUB<br/>คืออะไร</div>
            </v-card>
          </v-col>
          <v-col>
            <v-card
              class="pa-2 home-btn"
              outlined
              @click="changePage('howto')"
            >
              <div class="text-center mt-2">
                <img src="@/assets/images/home-icon-2.png" height="48px">
              </div>
              <div>วิธีการสมัคร<br/>LAMY CLUB</div>
            </v-card>
          </v-col>
          <v-col>
            <v-card
              class="pa-2 home-btn"
              outlined
              @click="changePage('term')"
            >
              <div class="text-center mt-2">
                <img src="@/assets/images/home-icon-3.png" height="48px">
              </div>
              <div>สมัคร<br/>LAMY CLUB</div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    
    </template>
    <div v-else class="text-center" style="padding-top: 70%;">
      <v-progress-circular
        indeterminate
        class="mt-6"
        color="primary"
        size="65"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>

import Header from "@/components/Header.vue";
export default {
  components: {
    Header
  },
  data() {
    return {
      loading: true,
    }
  },
  mounted() {
    this.loading = false
  },
  methods: {
    changePage(name) {
      var path = "/"+name;
      if (this.$route.path !== path) {
        this.$router.push({
          path: name,
          query: {...this.$route.query } ,
        }).catch({});
      }
    },
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
  }
  
};
</script>

<style>
.myshadow {
  -webkit-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
  box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.95);
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.headtext {
  color: white;
  position: absolute;
  left: 50%;
  top: 50%;
  font-weight: 300;
  transform: translate(-50%, -50%);
  font-size: 25px;
}
.home-btn {
  background-color: rgba(116,130,142,0.5) !important;
  color: #FFF !important;
  border: 1px solid #FFF !important;
  text-align: center;
}
</style>
